import React from 'react'
import PropTypes from 'prop-types'
import { formatMoney } from '../../../../util/money'
import Input from '../../../form/component/Input'


const InvoiceItemCorrectionForm = ({ invoiceItem, changeInvoiceCorrectionItem }) => {
    return (
        <tr>
            <td>{invoiceItem.name}</td>
            <td>{formatMoney(invoiceItem.brutPrice, invoiceItem.currency)}</td>
            <td>
                <Input
                    name="correctionAmount"
                    object={invoiceItem}
                    type="number"
                    max={invoiceItem.brutPrice / 100}
                    onChange={(name, value) => {
                        changeInvoiceCorrectionItem(invoiceItem.id, name, value)
                    }}/>
            </td>
        </tr>
    )
}


InvoiceItemCorrectionForm.propTypes = {
    invoiceItem: PropTypes.object.isRequired,
    changeInvoiceCorrectionItem: PropTypes.func.isRequired,
}


export default InvoiceItemCorrectionForm




// WEBPACK FOOTER //
// ./src/modules/invoice/component/correction/InvoiceItemCorrectionForm.js